import FlexContainerBase from './_flex-container-base.js'
import FlexItemBase from './_flex-item-base.js'
import ConfigurablePane from './_configurable-pane.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import ConfigurableSize from './_configurable-size.js'

export default {
  name: 'SwiperSlide',
  values: {
    style: {
      scrollSnapAlign: 'center',
      scrollSnapStop: 'always',
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: '100%',
      height: '100%',
      $mixin: [
        {
          configSet: FlexContainerBase,
        },
        {
          configSet: FlexItemBase,
        },
        {
          configSet: ConfigurablePane,
        },
        {
          configSet: ConfigurableSizeBounds,
        },
        {
          configSet: ConfigurableSize,
        },
      ],
    },
  },
  meta: {
    extendable: false,
  },
}
